import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../features/auth/AuthContext";
import { TimeRange } from "../../utils/timerange";
import { fetchUnprocessedCallsInsights } from "../queries/dashboard";

interface UseUnprocessedCallsInsightsParams {
  timeRange: TimeRange;
  timezone: string;
  protocol: string;
  user: string;
  callType: string;
  permittedEmails: string[] | null;
}

export const useUnprocessedCallsInsights = (params: UseUnprocessedCallsInsightsParams) => {
  const { tenantId } = useAuth();
  const { timeRange, timezone, protocol, user, callType, permittedEmails } = params;

  return useQuery({
    queryKey: ["unprocessedCallsInsights", tenantId, timeRange, timezone, protocol, user, callType, permittedEmails],
    queryFn: () => fetchUnprocessedCallsInsights(params),
    staleTime: 1 * 60 * 1000,
    gcTime: 2 * 60 * 1000,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};
